import { Link } from 'react-router-dom'
import { Facebook, Twitter, Instagram, Linkedin, Youtube, Mail } from 'lucide-react'
import { footerLinks } from '@/data/mock-data'

export default function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="bg-theme-elevated border-t border-slate-300 dark:border-slate-800">
            <div className="container mx-auto px-4 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
                    {/* Company Info */}
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center space-x-3 mb-6">
                            <img
                                src="/ff-logo.png"
                                alt="Future Foundeer"
                                className="h-12 w-auto"
                            />
                            <span className="text-xl font-display font-bold text-theme-primary">
                                Future Foundeer
                            </span>
                        </Link>
                        <p className="text-theme-secondary text-sm mb-6 max-w-sm">
                            Empowering future medical professionals with comprehensive NEET preparation,
                            expert mentorship, and innovative learning tools.
                        </p>
                        {/* Social Links */}
                        <div className="flex items-center space-x-4">
                            <a
                                href="#"
                                className="p-2 text-theme-muted hover:text-primary-blue transition-colors duration-200"
                                aria-label="Facebook"
                            >
                                <Facebook className="h-5 w-5" />
                            </a>
                            <a
                                href="#"
                                className="p-2 text-slate-400 hover:text-primary-blue transition-colors duration-200"
                                aria-label="Twitter"
                            >
                                <Twitter className="h-5 w-5" />
                            </a>
                            <a
                                href="#"
                                className="p-2 text-slate-400 hover:text-primary-blue transition-colors duration-200"
                                aria-label="Instagram"
                            >
                                <Instagram className="h-5 w-5" />
                            </a>
                            <a
                                href="#"
                                className="p-2 text-slate-400 hover:text-primary-blue transition-colors duration-200"
                                aria-label="LinkedIn"
                            >
                                <Linkedin className="h-5 w-5" />
                            </a>
                            <a
                                href="#"
                                className="p-2 text-slate-400 hover:text-primary-blue transition-colors duration-200"
                                aria-label="YouTube"
                            >
                                <Youtube className="h-5 w-5" />
                            </a>
                        </div>
                    </div>

                    {/* Products */}
                    <div>
                        <h3 className="text-theme-primary font-semibold mb-4">Products</h3>
                        <ul className="space-y-3">
                            {footerLinks.products.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-theme-secondary hover:text-theme-primary text-sm transition-colors duration-200"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-theme-primary font-semibold mb-4">Services</h3>
                        <ul className="space-y-3">
                            {footerLinks.services.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-theme-secondary hover:text-theme-primary text-sm transition-colors duration-200"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h3 className="text-theme-primary font-semibold mb-4">Company</h3>
                        <ul className="space-y-3">
                            {footerLinks.company.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-theme-secondary hover:text-theme-primary text-sm transition-colors duration-200"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Resources */}
                    <div>
                        <h3 className="text-theme-primary font-semibold mb-4">Resources</h3>
                        <ul className="space-y-3">
                            {footerLinks.resources.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-theme-secondary hover:text-theme-primary text-sm transition-colors duration-200"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Newsletter Section */}
                <div className="mt-12 pt-8 border-t border-slate-300 dark:border-slate-800">
                    <div className="max-w-md">
                        <h3 className="text-theme-primary font-semibold mb-2">Subscribe to our newsletter</h3>
                        <p className="text-theme-secondary text-sm mb-4">
                            Get the latest updates on courses, test series, and success stories.
                        </p>
                        <div className="flex gap-2">
                            <div className="relative flex-1">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-theme-muted" />
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className="w-full pl-10 pr-4 py-2.5 bg-slate-100 dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-lg text-theme-primary placeholder-slate-500 focus:outline-none focus:border-primary-blue transition-colors"
                                />
                            </div>
                            <button className="px-6 py-2.5 bg-primary-blue hover:bg-blue-600 text-white font-medium rounded-lg transition-all duration-200 glow-subtle hover:glow-primary whitespace-nowrap">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-12 pt-8 border-t border-slate-300 dark:border-slate-800">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-theme-secondary text-sm">
                            © {currentYear} Future Founder. All rights reserved.
                        </p>
                        <div className="flex gap-6 text-sm">
                            <Link to="#" className="text-theme-secondary hover:text-theme-primary transition-colors">
                                Privacy Policy
                            </Link>
                            <Link to="#" className="text-theme-secondary hover:text-theme-primary transition-colors">
                                Terms of Service
                            </Link>
                            <Link to="#" className="text-theme-secondary hover:text-theme-primary transition-colors">
                                Cookie Policy
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
